module.exports = __webpack_public_path__ + "img/slider_request-headers.f568832f.png";